import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from 'src/shared/globals';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root' // Makes the service a singleton available throughout the app
})
export class HomeService {
  // tslint:disable-next-line: variable-name
  constructor(private httpClient: HttpClient, private _global: Globals) {}

  PostService(endPoint: string, body: any): Observable<any> {
    const url = `${this._global.apiUrl}Property/${endPoint}`;
    return this.httpClient.post(url, body);
  }

  GetService(endPoint: string, body?: any): Observable<any> {
    const url = `${this._global.apiUrl}Property/${endPoint}`;
    return this.httpClient.get(url, body);
  }

  public getLocationsByCityId(cityId: any): Observable<any> {
   const url = `${this._global.apiUrl}Property/`;
   return this.httpClient.get(url + 'GetLocations?cityId=' + cityId);
  }

  HomeGetService(endPoint: string, body?: any): Observable<any> {
    const url = `${this._global.apiUrl}Home/${endPoint}`;
    return this.httpClient.get(url, body);
  }
}
